// extracted by mini-css-extract-plugin
export default {"container":"ML-z","dimension":"NL-z","dimensionLabels":"OL-z"};